import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import RepositorioDocumento from "../Repositorio/RepositorioDocumento";

const RepositorioDocumental = () => {
  const { proyecto } = useParams(); // Captura el código del proyecto de la URL
  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useState(true); // 👈 Abre por defecto

  const onCloseDrawable = () => {
    setOpenDrawer(false);
    // Al cerrar, vuelve atrás en el historial o a una ruta específica
    navigate(-1); // O por ejemplo navigate("/inicio");
  };

  return (
    <RepositorioDocumento
      open={openDrawer}
      onCloseMetodo={onCloseDrawable}
      proyectoCodigo={proyecto}
    />
  );
};

export default RepositorioDocumental;
